<template>
    <Teleport to="body">
        <div class="sf__parts__modal" @click="closeModal">
            <div class="sf__parts__modal__inner" @click.stop>
                <header class="sf__parts__modal__header">
                    <h3>Confirm your selection for:&nbsp;<strong>{{ parts[0].part }}</strong></h3>
                    <button type="button" class="sf__parts__modal__close" aria-label="Close" @click="closeModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </header>

                <div class="sf__parts__modal__body">
                    <p class="sf__parts__modal__intro">This product has multiple configurations. Please select the one that matches your vehicle.</p>
                    <div class="sf__parts__modal__notices sf__parts__modal__notices--desktop" v-if="selectedPart && selectedNotices.length">
                        <div
                            v-for="notice in selectedNotices"
                            :key="notice.key"
                            class="sf__parts__notice"
                            :class="notice.className"
                        >
                            <template v-if="notice.key === 'lead-time'">
                                <svg class="sf__parts__notice__status-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                    <path d="M15.62 7.08749L11.4044 2.84312C10.301 1.74245 8.80589 1.12465 7.24737 1.12535C5.68886 1.12605 4.19432 1.74521 3.0919 2.84687L2.23002 3.73624C2.16082 3.80777 2.12286 3.90386 2.1245 4.00337C2.12614 4.10288 2.16725 4.19766 2.23877 4.26687C2.3103 4.33607 2.40639 4.37403 2.5059 4.37239C2.60541 4.37075 2.70019 4.32964 2.7694 4.25812L3.62502 3.37499C4.00177 2.99757 4.43511 2.68127 4.9094 2.43749L7.9719 5.49999L1.88065 11.5875C1.79929 11.6688 1.73476 11.7653 1.69072 11.8715C1.64669 11.9777 1.62402 12.0916 1.62402 12.2066C1.62402 12.3215 1.64669 12.4354 1.69072 12.5416C1.73476 12.6479 1.79929 12.7444 1.88065 12.8256L3.17377 14.1187C3.25503 14.2 3.35149 14.2645 3.45766 14.3084C3.56382 14.3524 3.67761 14.3751 3.79252 14.3751C3.90744 14.3751 4.02123 14.3524 4.12739 14.3084C4.23356 14.2645 4.33002 14.2 4.41127 14.1187L10.5 8.02874L12.5888 10.1175C12.67 10.1988 12.7665 10.2632 12.8727 10.3072C12.9788 10.3512 13.0926 10.3738 13.2075 10.3738C13.3224 10.3738 13.4362 10.3512 13.5424 10.3072C13.6486 10.2632 13.745 10.1988 13.8263 10.1175L15.6188 8.32437C15.7829 8.16046 15.8752 7.93812 15.8754 7.70619C15.8756 7.47426 15.7838 7.25173 15.62 7.08749ZM3.88127 13.5881C3.86967 13.5997 3.85588 13.609 3.8407 13.6153C3.82553 13.6215 3.80926 13.6248 3.79284 13.6248C3.77641 13.6248 3.76014 13.6215 3.74497 13.6153C3.72979 13.609 3.71601 13.5997 3.7044 13.5881L2.41127 12.295C2.39965 12.2834 2.39043 12.2696 2.38414 12.2544C2.37785 12.2392 2.37461 12.223 2.37461 12.2066C2.37461 12.1901 2.37785 12.1739 2.38414 12.1587C2.39043 12.1435 2.39965 12.1297 2.41127 12.1181L6.75002 7.77874L8.2194 9.24999L3.88127 13.5881ZM10.235 7.23312L8.75002 8.71812L7.28002 7.24999L8.76502 5.76499C8.79989 5.73017 8.82755 5.68881 8.84642 5.64328C8.86529 5.59776 8.87501 5.54896 8.87501 5.49968C8.87501 5.4504 8.86529 5.4016 8.84642 5.35608C8.82755 5.31055 8.79989 5.2692 8.76502 5.23437L5.65877 2.12499C6.55891 1.83168 7.52266 1.7932 8.44331 2.01382C9.36397 2.23444 10.2056 2.70556 10.875 3.37499L13.7263 6.24562L11.75 8.21812L10.765 7.23312C10.6947 7.16289 10.5994 7.12345 10.5 7.12345C10.4006 7.12345 10.3053 7.16289 10.235 7.23312ZM15.0888 7.79562L13.2956 9.58937C13.284 9.60099 13.2703 9.61021 13.2551 9.6165C13.2399 9.62279 13.2236 9.62603 13.2072 9.62603C13.1908 9.62603 13.1745 9.62279 13.1593 9.6165C13.1442 9.61021 13.1304 9.60099 13.1188 9.58937L12.2806 8.74999L14.2531 6.77687L15.0888 7.61812C15.1119 7.64151 15.1248 7.67306 15.1248 7.70593C15.1248 7.7388 15.1119 7.77035 15.0888 7.79374V7.79562Z" fill="currentColor"/>
                                </svg>
                                <p class="sf__parts__notice__status-copy">
                                    <strong>Note:</strong>&nbsp;This product configuration is
                                    <span>{{ notice.label }}:&nbsp;</span>{{ notice.detailBefore }}<span v-if="notice.detailHighlight">{{ notice.detailHighlight }}</span>{{ notice.detailAfter }}
                                </p>
                            </template>
                            <div class="sf__parts__notice__content" v-else>
                                <h4>
                                    <span aria-hidden="true">{{ notice.icon }}</span>
                                    {{ notice.title }}
                                </h4>
                                <p>{{ notice.detail }}</p>
                            </div>
                            <img v-if="notice.image" :src="notice.image" :alt="notice.imageAlt">
                        </div>
                    </div>
                </div>

                <div class="sf__parts__modal__list">
                    <template v-for="part in parts" :key="part.build_id">
                        <Part
                            :specific="true"
                            :videos="videos"
                            :group="true"
                            :selectable="true"
                            :selected="selectedPart && selectedPart.build_id === part.build_id"
                            :compact-status="true"
                            :part="part"
                            @select="selectPart"
                        />
                        <div
                            class="sf__parts__modal__notices sf__parts__modal__notices--mobile"
                            v-if="selectedPart && selectedPart.build_id === part.build_id && selectedNotices.length"
                        >
                            <div
                                v-for="notice in selectedNotices"
                                :key="notice.key"
                                class="sf__parts__notice"
                                :class="notice.className"
                            >
                                <template v-if="notice.key === 'lead-time'">
                                    <svg class="sf__parts__notice__status-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                        <path d="M15.62 7.08749L11.4044 2.84312C10.301 1.74245 8.80589 1.12465 7.24737 1.12535C5.68886 1.12605 4.19432 1.74521 3.0919 2.84687L2.23002 3.73624C2.16082 3.80777 2.12286 3.90386 2.1245 4.00337C2.12614 4.10288 2.16725 4.19766 2.23877 4.26687C2.3103 4.33607 2.40639 4.37403 2.5059 4.37239C2.60541 4.37075 2.70019 4.32964 2.7694 4.25812L3.62502 3.37499C4.00177 2.99757 4.43511 2.68127 4.9094 2.43749L7.9719 5.49999L1.88065 11.5875C1.79929 11.6688 1.73476 11.7653 1.69072 11.8715C1.64669 11.9777 1.62402 12.0916 1.62402 12.2066C1.62402 12.3215 1.64669 12.4354 1.69072 12.5416C1.73476 12.6479 1.79929 12.7444 1.88065 12.8256L3.17377 14.1187C3.25503 14.2 3.35149 14.2645 3.45766 14.3084C3.56382 14.3524 3.67761 14.3751 3.79252 14.3751C3.90744 14.3751 4.02123 14.3524 4.12739 14.3084C4.23356 14.2645 4.33002 14.2 4.41127 14.1187L10.5 8.02874L12.5888 10.1175C12.67 10.1988 12.7665 10.2632 12.8727 10.3072C12.9788 10.3512 13.0926 10.3738 13.2075 10.3738C13.3224 10.3738 13.4362 10.3512 13.5424 10.3072C13.6486 10.2632 13.745 10.1988 13.8263 10.1175L15.6188 8.32437C15.7829 8.16046 15.8752 7.93812 15.8754 7.70619C15.8756 7.47426 15.7838 7.25173 15.62 7.08749ZM3.88127 13.5881C3.86967 13.5997 3.85588 13.609 3.8407 13.6153C3.82553 13.6215 3.80926 13.6248 3.79284 13.6248C3.77641 13.6248 3.76014 13.6215 3.74497 13.6153C3.72979 13.609 3.71601 13.5997 3.7044 13.5881L2.41127 12.295C2.39965 12.2834 2.39043 12.2696 2.38414 12.2544C2.37785 12.2392 2.37461 12.223 2.37461 12.2066C2.37461 12.1901 2.37785 12.1739 2.38414 12.1587C2.39043 12.1435 2.39965 12.1297 2.41127 12.1181L6.75002 7.77874L8.2194 9.24999L3.88127 13.5881ZM10.235 7.23312L8.75002 8.71812L7.28002 7.24999L8.76502 5.76499C8.79989 5.73017 8.82755 5.68881 8.84642 5.64328C8.86529 5.59776 8.87501 5.54896 8.87501 5.49968C8.87501 5.4504 8.86529 5.4016 8.84642 5.35608C8.82755 5.31055 8.79989 5.2692 8.76502 5.23437L5.65877 2.12499C6.55891 1.83168 7.52266 1.7932 8.44331 2.01382C9.36397 2.23444 10.2056 2.70556 10.875 3.37499L13.7263 6.24562L11.75 8.21812L10.765 7.23312C10.6947 7.16289 10.5994 7.12345 10.5 7.12345C10.4006 7.12345 10.3053 7.16289 10.235 7.23312ZM15.0888 7.79562L13.2956 9.58937C13.284 9.60099 13.2703 9.61021 13.2551 9.6165C13.2399 9.62279 13.2236 9.62603 13.2072 9.62603C13.1908 9.62603 13.1745 9.62279 13.1593 9.6165C13.1442 9.61021 13.1304 9.60099 13.1188 9.58937L12.2806 8.74999L14.2531 6.77687L15.0888 7.61812C15.1119 7.64151 15.1248 7.67306 15.1248 7.70593C15.1248 7.7388 15.1119 7.77035 15.0888 7.79374V7.79562Z" fill="currentColor"/>
                                    </svg>
                                    <p class="sf__parts__notice__status-copy">
                                        <strong>Note:</strong>&nbsp;This product configuration is
                                        <span>{{ notice.label }}:&nbsp;</span>{{ notice.detailBefore }}<span v-if="notice.detailHighlight">{{ notice.detailHighlight }}</span>{{ notice.detailAfter }}
                                    </p>
                                </template>
                                <div class="sf__parts__notice__content" v-else>
                                    <h4>
                                        <span aria-hidden="true">{{ notice.icon }}</span>
                                        {{ notice.title }}
                                    </h4>
                                    <p>{{ notice.detail }}</p>
                                </div>
                                <img v-if="notice.image" :src="notice.image" :alt="notice.imageAlt">
                            </div>
                        </div>
                    </template>
                </div>

                <footer class="sf__parts__modal__footer">
                    <button type="button" class="sf__parts__modal__secondary" @click="closeModal">Go Back</button>
                    <button type="button" class="sf__parts__modal__primary" :disabled="!selectedPart || !selectedAvailable || adding" @click="confirmSelection">
                        <span v-if="adding" class="sf__parts__modal__button-loader"></span>
                        <span v-else>
                            <span class="sf__parts__modal__label--desktop">Confirm &amp; Add to Cart</span>
                            <span class="sf__parts__modal__label--mobile">Confirm &amp; Add</span>
                        </span>
                    </button>
                </footer>
            </div>
        </div>
    </Teleport>
</template>

<script>
import Part from './Part.vue';
import store from '../store';
import Storage from '../helpers/storage';

export default {
    props: ['parts', 'videos'],

    components: {
        Part
    },

    data() {
        return {
            selectedPart: null,
            adding: false
        }
    },

    computed: {
        selectedStatus() {
            if (!this.selectedPart) return null;
            return store.products[this.selectedPart.build_id]?.status || null;
        },

        selectedAvailable() {
            if (!this.selectedPart) return false;

            const product = store.products[this.selectedPart.build_id];
            const unavailableStatuses = ['discontinued', 'out-of-stock', 'back-ordered', 'coming-soon'];

            return Boolean(product?.available) && !unavailableStatuses.includes(product?.status?.key);
        },

        selectedNotices() {
            if (!this.selectedPart) return [];

            const notices = [];

            if (this.selectedPart.exception) {
                notices.push({
                    key: 'exception',
                    className: 'sf__parts__notice--exception',
                    icon: 'i',
                    title: 'Exception',
                    detail: this.selectedPart.exception,
                    image: this.selectedPart.exception_image,
                    imageAlt: 'Exception details'
                });
            } else if (this.selectedStatus?.key === 'made-to-order') {
                const detail = this.selectedStatus.detail || '';
                const detailMatch = detail.match(/^(.*?)(\d+\s+(?:business\s+)?(?:days?|weeks?))(.*)$/i);

                notices.push({
                    key: 'lead-time',
                    className: `sf__parts__notice--status sf__parts__notice--status-${this.selectedStatus.key}`,
                    label: this.selectedStatus.label,
                    detailBefore: detailMatch ? detailMatch[1] : detail,
                    detailHighlight: detailMatch ? detailMatch[2] : '',
                    detailAfter: detailMatch ? detailMatch[3] : ''
                });
            }

            return notices;
        }
    },

    methods: {
        closeModal(event) {
            event?.stopPropagation?.();
            this.$emit('onClose');
        },

        selectPart(part) {
            const product = store.products[part.build_id];
            const unavailableStatuses = ['discontinued', 'out-of-stock', 'back-ordered', 'coming-soon'];

            if (!product?.available || unavailableStatuses.includes(product?.status?.key)) return;

            this.selectedPart = part;
            this.$nextTick(() => {
                if (!window.matchMedia('(max-width: 767px)').matches) return;

                const selectedCard = document.querySelector('.sf__parts__modal__list .sf__results__result--selected');
                const selectedNotice = selectedCard?.nextElementSibling?.classList.contains('sf__parts__modal__notices--mobile')
                    ? selectedCard.nextElementSibling
                    : null;

                (selectedNotice || selectedCard)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            });
        },

        async confirmSelection() {
            if (!this.selectedPart || !this.selectedAvailable) return;

            this.adding = true;
            try {
                const response = await this.selectedPart.addToCart();
                Storage.storeRecommendations(this.selectedPart.build_id, store.results_page);
                if (typeof window.sf_options?.afterAddToCart === 'function') {
                    window.sf_options.afterAddToCart(response);
                }
                this.$emit('onClose');
            } catch (error) {
                console.error(error);
            } finally {
                this.adding = false;
            }
        }
    }
}
</script>
